import React from 'react';
import PropTypes from 'prop-types';

function CrossDeviceLoginCodeModalBody({ code, translate }) {
  return (
    <div>
      <div className='cross-device-login-display-code-modal-image' />
      <div className='font-title'>{code}</div>
      <div className='cross-device-login-device-promp-text font-header-2'>
        {translate('Label.DevicePrompt')}
      </div>
      <div className='cross-device-login-instruction-text font-caption-header'>
        {translate('Label.LoginInstructions')}
      </div>
      <div
        className='cross-device-login-instruction-text font-caption-header'
        dangerouslySetInnerHTML={{
          __html: translate('Label.LoginLocation')
        }}
      />
    </div>
  );
}

CrossDeviceLoginCodeModalBody.propTypes = {
  translate: PropTypes.func.isRequired,
  code: PropTypes.string.isRequired
};

export default CrossDeviceLoginCodeModalBody;
